export default {"src":"/_next/static/image/public/images/ic_huawei_appgallery.c9a90e487b086b989c310b47671344c7.svg","height":36,"width":108};